import request from '../utils/request'

//BPC配置数据接口-田海光
export default {
	//设备列表查询-姜飞
	configData({dicType}) {
		return request({
			method: 'get',
			url: `/bpc/configData?dicType=${dicType}`
		})
	},
	findListReviewNote(configurationId) {
		return request({
			method: 'get',
			url: `/bpc/manager/buget/listReviewNote?configurationId=${configurationId}`,
		})
	},
	//预算填报发布后撤回-李旭
	bugetRecall({configurationId, personName, personCode}) {
		return request({
			method: 'get',
			url: `/bpc/common/buget/recall?configurationId=${configurationId}&personName=${personName}&personCode=${personCode}`,
		})
    },

}